import type { FilterState, GraphNode, GraphFacetFilterDef } from "../types/graph";

function metaValueForFilter(
  meta: GraphNode["meta"],
  filterKey: GraphFacetFilterDef["filterKey"],
) {
  if (!meta) return undefined;
  switch (filterKey) {
    case "priorities":
      return meta.priority;
    case "impactTypes":
      return meta.impactType;
    case "riskLevels":
      return meta.riskLevel;
    case "geoAreas":
      return meta.geoArea;
    case "trades":
      return meta.trades;
    default:
      return undefined;
  }
}

/** Apply registry-aligned facet filters to an inspection node. */
export function inspectionMatchesFacetFilters(
  node: GraphNode,
  filter: FilterState,
  bindings: GraphFacetFilterDef[],
): boolean {
  if (node.type !== "inspection") return true;

  for (const binding of bindings) {
    const selected = filter[binding.filterKey];
    if (!selected?.length) continue;

    if (binding.filterKey === "trades") {
      const trades = metaValueForFilter(node.meta, "trades") ?? [];
      if (!selected.some((t) => trades.includes(t))) return false;
      continue;
    }

    const value = metaValueForFilter(node.meta, binding.filterKey);
    if (value == null || !selected.includes(String(value))) return false;
  }

  return true;
}
